import { Document, Page, Text, View } from '@react-pdf/renderer';
import { type IQualification, type IQualificationReport } from 'src/models';
import _ from 'lodash';
import styles from './QualificationsPdf-styles';

interface Props {
	data: any[];
}

function QualificationsPdf({ data }: Props) {
	return (
		<Document>
			{data?.map((report: IQualificationReport, index: number) => (
				<Page key={index} size={'A4'} style={styles.page}>
					<Text style={styles.subtitle}> Reporte de usuario </Text>

					<Text style={styles.title}> {report.username} </Text>

					<Text style={styles.courseName}> {report.course} </Text>

					<View style={styles.headers}>
						<Text
							style={{
								...styles.headerItem,
								textAlign: 'left',
								width: '30%',
							}}
						>
							{' '}
							Item{' '}
						</Text>

						<Text style={styles.headerItem}> Ponderación </Text>

						<Text style={styles.headerItem}> Calificación </Text>

						<Text style={styles.headerItem}> Porcentaje </Text>

						{/* <Text style={styles.headerItem}> Promedio </Text> */}
						<Text style={styles.headerItem}>
							{' '}
							Contribución al total{' '}
						</Text>
					</View>

					<View style={styles.divider} />

					{_.filter(report.qualifications, { isTotal: false }).map(
						(qualification: IQualification, index: number) => (
							<View key={index} style={styles.row}>
								<Text
									style={{
										...styles.cell,
										textAlign: 'left',
										width: '30%',
									}}
								>
									{' '}
									{qualification.section}{' '}
								</Text>

								<Text style={styles.cell}>
									{' '}
									{qualification.weighing}%{' '}
								</Text>

								<Text style={styles.cell}>
									{' '}
									{qualification.score}{' '}
								</Text>

								<Text style={styles.cell}>
									{' '}
									{qualification.percentage}%{' '}
								</Text>

								<Text style={styles.cell}>
									{' '}
									{qualification.score}%{' '}
								</Text>
							</View>
						),
					)}

					{_.filter(report.qualifications, { isTotal: true }).map(
						(qualification: IQualification, index: number) => (
							<View key={index} style={styles.row}>
								<Text
									style={{
										...styles.cell,
										fontSize: 13,
										fontWeight: 'bold',
										textAlign: 'left',
										width: '30%',
									}}
								>
									{' '}
									Total de curso{' '}
								</Text>

								<Text style={styles.cell} />

								<Text
									style={{
										...styles.cell,
										fontSize: 13,
										fontWeight: 'bold',
									}}
								>
									{' '}
									{qualification.totalScore}{' '}
								</Text>

								<Text
									style={{
										...styles.cell,
										fontSize: 13,
										fontWeight: 'bold',
									}}
								>
									{' '}
									{qualification.totalPercentage}%{' '}
								</Text>

								<Text style={styles.cell} />
							</View>
						),
					)}
				</Page>
			))}
		</Document>
	);
}

export default QualificationsPdf;
